import { Component, OnInit, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import * as models from '../../models';
import * as fromRootStore from '../../../store';
import * as sharedDataActions from '../../../store/actions/shared-data.action';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
  selector: 'dd-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PageNotFoundComponent implements OnInit, OnDestroy {

  @Input() errorText = "";
  @Input() directionText = "";
  // Observable to save inventory screen data
  sharedDataStore$: Observable<models.SharedData>;
  // Subscriber for Shared Data Store
  sharedDataStoreSubscriber: any;
  // Field to store Shared Data from store
  sharedData: models.SharedData = <models.SharedData>{};

  constructor(public store: Store<fromRootStore.IAppState>) {
    this.sharedDataStore$ = store.select(fromRootStore.SharedDataStore);
  }

  ngOnInit() {
    this.sharedDataStoreSubscriber = this.sharedDataStore$.subscribe(data => {
      // console.log('SHARED DATA REDUCER: ' + JSON.stringify(data));
      this.sharedData = Object.assign({}, data);
    });
    this.setLayout(false);
  }

  ngOnDestroy() {
    this.setLayout(true);
  }

  setLayout(flag: boolean) {
    this.sharedData.showHeader = flag;
    this.sharedData.showMenu = flag;
    this.sharedData.showFooter = flag;
    this.store.dispatch(new sharedDataActions.SetSharedDataAction(this.sharedData));
  }

}
